import {
  ShoppingCartProductType,
  ShippingMethodTypes,
  type PreferredShippingMethod,
} from '@monofront/types';
import { DeliveryBarMachineContext } from '../contexts/DeliveryBarContext';
import { getIsFresh, getIsUltraFresh } from '../utils';
import { EVENTS } from '../stateMachines/deliveryBar/events';
import {
  useFetchEligibleShippingMethods,
  usePreferredShippingMethodWithConfigurations,
} from './usePreferredShippingMethodWithConfigurations';

type UseDeliveryBarSwitchPickupToCourierParams = {
  customer: {
    address?: {
      street: string;
      city: string;
      postalCode: string;
      country: string;
    } | null;
    preferredShippingMethod?: PreferredShippingMethod | null;
  } | null;
  shoppingCartProduct: ShoppingCartProductType;
  onSwitchCallback?: {
    success?: () => void;
    error?: () => void;
  };
};

export const useDeliveryBarSwitchPickupToCourier = ({
  customer,
  shoppingCartProduct,
  onSwitchCallback,
}: UseDeliveryBarSwitchPickupToCourierParams) => {
  const { send } = DeliveryBarMachineContext.useActorRef();

  const selectedShippingMethod = usePreferredShippingMethodWithConfigurations({
    address: customer?.address ?? null,
    preferredShippingMethod: customer?.preferredShippingMethod ?? null,
  });

  const selectedShippingMethods = useFetchEligibleShippingMethods(
    customer?.address,
  );

  const deliveryBarSwitchPickupToCourier = () => {
    if (
      (getIsFresh(shoppingCartProduct.tags) ||
        getIsUltraFresh(shoppingCartProduct.tags)) &&
      selectedShippingMethod?.type === ShippingMethodTypes.PICKUP
    ) {
      const courierShippingMethod = selectedShippingMethods.find(
        (method) => method.type === ShippingMethodTypes.COURIER,
      );

      if (!courierShippingMethod) {
        onSwitchCallback?.error?.();

        return;
      }

      send({
        type: EVENTS.OVERWRITE_SHIPPING_METHOD,
        shippingMethod: {
          type: ShippingMethodTypes.COURIER,
          carrierId: courierShippingMethod.carrierId,
        },
      });

      onSwitchCallback?.success?.();
    }
  };

  return { deliveryBarSwitchPickupToCourier };
};
